/**
 * Adds functionality for dropdown to footer area.
 */
jQuery(function($){
    var selector = '.menu-item.dropdown';
    if (!$(selector).length) return;
    function isOverflowBottom(elem, padding) {
        padding = padding ? padding : 0;
        var bounding = elem.getBoundingClientRect();
        return (bounding.bottom + padding) > (window.innerHeight || document.documentElement.clientHeight);
    }
    $(document).on('mouseenter mouseleave', selector, function(e){
        if ('mouseenter' == e.type) $(this).removeClass('out').addClass('over');
        else $(this).removeClass('over').addClass('out');
        var subMenuEl = $(this).find('> .sub-menu');
        if ('mouseenter' == e.type && subMenuEl.length) {
            $(this).removeClass('above below');
            if (isOverflowBottom(subMenuEl[0], 15)) $(this).addClass('above');
            else $(this).addClass('below');
        }
    });
    $(selector).trigger('mouseleave');
});
